import { checkIfResponseSuccessV2 } from 'owa-service-utils/lib/checkIfResponseSuccess';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';

export default function checkIfResponseSuccess(response: SingleResponseMessage) {
    return checkIfResponseSuccessV2(response);
}
